import React, { useState, useEffect } from 'react'

export default function AdditionalProfilesModal({plan, close, handleSubmit, saving, team}) {
    const [additionalProfiles, setAdditionalProfiles] = useState(0)
    const [warningMessage, setWarningMessage] = useState('')
    const cost = team.use_custom_pricing ? team.profile_cost : 5


    useEffect(() => {
        if (additionalProfiles < 100) {
            setWarningMessage('Additional profiles cannot be less than 100')
            return
        }

        if (additionalProfiles % 100 !== 0) {
            setWarningMessage('Additional profiles needs to be in increments of 100')
            return
        }

        setWarningMessage('')
    }, [additionalProfiles])

    const getTotalAmount = () => {
        if (!additionalProfiles || warningMessage.length > 0) {
            return 0
        }

        if (additionalProfiles && warningMessage.length < 1) {
            let units = additionalProfiles / 100
            let amount = units * cost
            return amount
        }
    }

  return (
    <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
        <div className="bg-white mx-auto rounded shadow p-5 text-center">
            <h2>Purchase Additional Profiles</h2>
            <p>
                You already have {plan.name == 'Free Trial' ? plan.next_billing.profile_limit : plan.profile_limit} Profiles, you can purchase additional profiles and we will only charge you for 
                the days remaining until {plan.end_date}, afterwards you will be charged the full amount
            </p>

            <div>
                <div className="form-group rd-pad-in">
                    <label className='profile'>Additional Profiles (increment of 100)</label>
                    <input 
                        type='number'
                        step={100}
                        className='form-control'
                        id='profile'
                        value={additionalProfiles}
                        onChange={(e) => {
                            setAdditionalProfiles(e.target.value)
                        }}
                    />
                </div>
                <small className='text-danger'>{warningMessage}</small>
            </div>

            <h4>Total Amount: ${ parseFloat(getTotalAmount()).toFixed(2) } USD</h4>

            <div className="pt-3">
                <button onClick={() => handleSubmit(additionalProfiles)} type="button" className="btn btn-primary mr-2" disabled={saving || warningMessage.length > 0}>
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                    Proceed
                </button>

                <button onClick={close} type="button" className="btn btn-danger mr-2" disabled={saving}>
                    Cancel
                </button>
            </div>
        </div>
    </div>
  )
}
